// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FolderPlusOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 1024 1024","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M128 192v640h768V320H485.76L357.5 192H128zm-32-64h287.87l128.39 128H928a32 32 0 0132 32v576a32 32 0 01-32 32H96a32 32 0 01-32-32V160a32 32 0 0132-32zm384 416V416h64v128h128v64H544v128h-64V608H352v-64h128z"}}]},"name":"folder-plus","theme":"outlined"};

const FolderPlusOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FolderPlusOutlinedSvg} />;
  FolderPlusOutlined.displayName = 'FolderPlusOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FolderPlusOutlined);
